
import { h, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { withHydration } from '@util/hydrate'
import { json } from '@util/request'
import Staggered from '@components/staggered'
import SocialPost from '@components/social-post'
import { dateFormat } from '@util/date'

const SocialGrid = ({ apiKey, feedId, networkId }) => {

	const [posts, setPosts] = useState([])

	const url = `https://api.curator.io/v1/feeds/${feedId}/posts?api_key=${apiKey}&network_id=${networkId}`

	useEffect(() => {
	    json(url, function(response) {
    		const latest = response
    			?.posts
    			?.filter(post => post.has_image && !post.is_deleted)
    		setPosts(latest)
    	})
	  }, [])

	return <Staggered>
		{posts.map(post => {
			return <SocialPost 
				href={post.url} 
				image={{ src : post.image_large || post.image }} 
				text={post.text}
				date={dateFormat(post.source_created_at)} 
				userurl={post.user_url}
				username={post.user_screen_name}
			/>
		})}
	</Staggered>
}

export default withHydration(SocialGrid)